import React from 'react';

const BoligmappaPlusHomeIcon = ({
  width = '15',
  height = '15',
  stroke = '#222222',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_3643_1503)">
      <path
        d="M7.49884 13.5748C7.49884 11.6551 4.42624 11.1002 2.65099 10.9396C2.31465 10.9089 2.00204 10.7532 1.77486 10.5033C1.54769 10.2533 1.42244 9.92734 1.42384 9.5896V2.7748C1.42391 2.58548 1.46379 2.3983 1.54091 2.2254C1.61802 2.05251 1.73063 1.89776 1.87144 1.77121C2.01224 1.64467 2.17809 1.54915 2.35821 1.49087C2.53833 1.43258 2.72869 1.41283 2.91694 1.4329C4.71514 1.62325 7.49884 2.2132 7.49884 4.0411V13.5748Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 13.5748C7.5 11.6551 10.5726 11.1002 12.3479 10.9396C12.6842 10.9089 12.9968 10.7532 13.224 10.5033C13.4512 10.2533 13.5764 9.92734 13.575 9.5896V2.7748C13.5749 2.58548 13.535 2.3983 13.4579 2.2254C13.3808 2.05251 13.2682 1.89776 13.1274 1.77121C12.9866 1.64467 12.8207 1.54915 12.6406 1.49087C12.4605 1.43258 12.2701 1.41283 12.0819 1.4329C10.2837 1.62325 7.5 2.2132 7.5 4.0411V13.5748Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3643_1503">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BoligmappaPlusHomeIcon;
